import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import SvgIcon from "@mui/material/SvgIcon";
import { Link as RouterLink } from "react-router-dom";
import YouTubeIcon from "@mui/icons-material/YouTube";

function DiscordIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path d="M20.317 4.37a19.791 19.791 0 00-4.885-1.515.074.074 0 00-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 00-5.487 0 12.64 12.64 0 00-.617-1.25.077.077 0 00-.079-.037A19.736 19.736 0 003.677 4.37a.07.07 0 00-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 00.031.057 19.9 19.9 0 005.993 3.03.078.078 0 00.084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 00-.041-.106 13.107 13.107 0 01-1.872-.892.077.077 0 01-.008-.128 10.2 10.2 0 00.372-.292.074.074 0 01.077-.01c3.927 1.793 8.18 1.793 12.062 0a.074.074 0 01.078.01c.12.098.246.198.373.292a.077.077 0 01-.006.127 12.299 12.299 0 01-1.873.892.077.077 0 00-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 00.084.028 19.839 19.839 0 006.002-3.03.077.077 0 00.032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 00-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.211 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z" />
    </SvgIcon>
  );
}

function TwitchIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path d="M2 2L1 6v14h5v3h3l3-3h4l7-7V2H2zm19 10l-4 4h-5l-3 3v-3H5V4h16v8z" />
      <path d="M17 7h2v5h-2zM11 7h2v5h-2z" />
    </SvgIcon>
  );
}

export default function Footer() {
  return (
    <Container sx={{ py: 8 }} maxWidth="lg">
      <Grid container spacing={4}>
        <Grid item key="footer-links" xs={12} sm={12} md={6} lg={3}>
          <Paper sx={{ p: 6 }} component="footer">
            <Typography
              variant="h6"
              align="center"
              fontWeight="bold"
              gutterBottom
            >
              Links
            </Typography>
            <Typography
              variant="subtitle1"
              align="center"
              color="text.secondary"
              component="div"
            >
              <p>
                <Link component={RouterLink} to="/site-menu" color="inherit" underline="hover">
                  Site Menu
                </Link>
              </p>
              <noscript>
                <p>
                  <a href="/site-menu">Site Menu</a>
                </p>
              </noscript>
              <p>
                <Link component={RouterLink} to="/map" color="inherit" underline="hover">
                  Map
                </Link>
              </p>
              <p>
                <a href="https://mcverse-store.tebex.io/category/2550414">
                  Support Shop
                </a>
              </p>
              <Box
                sx={{
                  mt: 1.5,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 1.5,
                }}
              >
                <Link
                  href="https://discord.gg/4z6bf9sy44"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="MCVerse Discord"
                  color="inherit"
                >
                  <DiscordIcon />
                </Link>
                <Link
                  href="https://www.youtube.com/@MCVerseCity"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="MCVerse YouTube"
                  color="inherit"
                >
                  <YouTubeIcon />
                </Link>
                <Link
                  href="https://www.twitch.tv/mcversecity"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="MCVerse Twitch"
                  color="inherit"
                >
                  <TwitchIcon />
                </Link>
              </Box>
            </Typography>
          </Paper>
        </Grid>

        <Grid item key="footer-disclaimer" xs={12} sm={12} md={6} lg={3}>
          <Paper sx={{ p: 6 }} component="footer">
            <Typography variant="p" align="center" gutterBottom>
              Not an official Minecraft Service. <br />
              <br />
              Not approved by Mojang or Microsoft
            </Typography>
          </Paper>
        </Grid>

        <Grid item key="footer-store-banner" xs={12} sm={12} md={6} lg={3}>
          <Paper
            sx={{
              p: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            component="footer"
          >
            <Link
              href="https://mcverse-store.tebex.io/"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ display: "block", lineHeight: 0 }}
            >
              <Box
                component="img"
                src="/imgs/mcv-2026-annual-rank-support-survival-minecraft.jpg"
                alt="MCV 2026 Annual Rank — Support the Server"
                sx={{
                  width: "100%",
                  maxWidth: 200,
                  height: "auto",
                  display: "block",
                }}
              />
            </Link>
          </Paper>
        </Grid>
        <Grid item key="footer-top-sites" xs={12} sm={12} md={6} lg={3}>
          <Paper sx={{ p: 6 }} component="footer">
            <Typography
              variant="h6"
              align="center"
              fontWeight="bold"
              gutterBottom
            >
              Contact Email
            </Typography>
            <Typography
              variant="subtitle1"
              align="center"
              color="text.secondary"
              component="div"
            >
              <p>
                <a href="mailto:mcversecity@outlook.com">mcversecity@outlook.com</a>
                <br />
                Formal & Business Inquiries Only
              </p>
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}
